import { gql, useMutation } from '@apollo/client';
import { AnonCriteriaFragment } from '../constants';

const EditCriteriaMutation = gql`
  mutation editCriteria($id: Long!, $criteria: EditableAnonUserCriteriaInput!) {
    updateAnonUserCriteria(id: $id, criteria: $criteria) {
      payload {
        ...AnonCriteria
      }
      failure {
        ... on AnonUserCriteriaCreationFailure {
          message
        }
        ... on AnonUserCriteriaInvalidSearchQuery {
          message
        }
        ... on AnonUserCriteriaNameAlreadyExistsFailure {
          message
        }
        ... on AnonUserCriteriaNotFoundFailure {
          message
        }
        ... on AnonUserCriteriaUpdateFailure {
          message
        }
      }
    }
  }
  ${AnonCriteriaFragment}
`;

export const useEditCriteria = () => {
  const [editCriteria] = useMutation(EditCriteriaMutation);

  return {
    editCriteria,
  };
};
